import React, { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./Flamingo.css";
import flamingo1 from "../images/flamingo1.jpeg";
import flamingo2 from "../images/flamingo2.jpeg";

function Flamingo() {
  // Comments state
  const [comments, setComments] = useState([]);
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  // Fetch comments from backend
  useEffect(() => {
    fetch("http://localhost:5000/api/flamingo-comments")
      .then((res) => res.json())
      .then((data) => setComments(Array.isArray(data) ? data : []))
      .catch((err) => console.error(err));
  }, []);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle comment submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.message) return alert("Enter your name and comment!");

    try {
      const res = await fetch("http://localhost:5000/api/flamingo-comments", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const newComment = await res.json();
      setComments([newComment, ...(Array.isArray(comments) ? comments : [])]);
      setFormData({ name: "", email: "", message: "" });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="flamingo-page">
      

      <main className="flamingo-content">
        {/* Hero Section */}
        <section className="flamingo-hero">
          <h2>Flamingos</h2>
          <p>
            Flamingos are tall, pink wading birds known for their long legs and unique beaks.
          </p>
        </section>

        {/* Images Section */}
        <section className="flamingo-images">
          <img src={flamingo1} alt="Flamingo 1" />
          <img src={flamingo2} alt="Flamingo 2" />
        </section>

        {/* Info Section */}
        <section className="flamingo-info">
          <h3>Locations</h3>
          <p>
            Flamingos are found in Africa, South America, and parts of Asia, usually near lakes and lagoons.
          </p>
        </section>

        {/* Comments Section */}
        <section className="comments-section">
          <h2>Community Comments</h2>

          <form className="comment-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email (optional)"
              value={formData.email}
              onChange={handleChange}
            />
            <textarea
              name="message"
              placeholder="Write your comment..."
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit">Post Comment</button>
          </form>

          <div className="comment-list">
            {comments && comments.length > 0 ? (
              comments.map((c) => (
                <div key={c._id || c.id} className="comment">
                  <strong>{c.name}</strong> ({new Date(c.date).toLocaleString()}):
                  <p>{c.message}</p>
                </div>
              ))
            ) : (
              <p>No comments yet.</p>
            )}
          </div>
        </section>
      </main>

    </div>
  );
}

export default Flamingo;
